import React from "react"
import { Grid } from "react-loader-spinner"
import { Wrapper } from "./style"

const Spinner = ({ maxHeight }) => (
  <Wrapper maxHeight={maxHeight}>
    <Grid
      height="80"
      width="80"
      color="var(--custom-secondary)"
      ariaLabel="grid-loading"
      radius="12.5"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
    />
  </Wrapper>
)

export default React.memo(Spinner)
